export default "__VITE_ASSET__bOQaMED3__"